'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Button;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypesElementtype = require('prop-types-elementtype');

var _propTypesElementtype2 = _interopRequireDefault(_propTypesElementtype);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _mergeProps = require('../../utils/mergeProps');

var _mergeProps2 = _interopRequireDefault(_mergeProps);

var _SpacerElement = require('../../internal/SpacerElement');

var _SpacerElement2 = _interopRequireDefault(_SpacerElement);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _LoadingIndicator = require('../LoadingIndicator');

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  'wrapper': 'ccl-67e0c7f3fe50cf69',
  'button': 'ccl-d0484b0360a2b432',
  'mediumSize': 'ccl-ed9aadeaa18a9f19',
  'smallSize': 'ccl-84d4514e64aa4a15',
  'buttonContent': 'ccl-cce251427bbe4ec4',
  'isLoading': 'ccl-eabd60384ef8e0cc',
  'placeholder': 'ccl-3719652695adbd23',
  'isBlock': 'ccl-a97a150ddadaa172',
  'loadingIndicator': 'ccl-bcc9a0f0df5c2b78',
  'isDisabled': 'ccl-ad5c63fbcb2e2f86',
  'isInverted': 'ccl-270e98a6090de3bc',
  'primary': 'ccl-233931c277401e86',
  'primaryAlt': 'ccl-0e79e82bfea32615',
  'secondary': 'ccl-5f83ec16556720ae',
  'secondaryAlt': 'ccl-48219f0ea818e3c1',
  'destructive': 'ccl-84274627c639e05a',
  'tertiary': 'ccl-507a01f1bfa88f63',
  'tertiaryAlt': 'ccl-f6d0e8228d1371a4'
};

/**
 * A description of this component.
 */

function Button(originalProps) {
  var _classnames;

  var isPlaceholder = originalProps.isPlaceholder;

  var props = isPlaceholder ? (0, _mergeProps2.default)(originalProps, Button.placeholderProps) : originalProps;
  var id = props.id,
      isLoading = props.isLoading,
      isBlock = props.isBlock,
      isInverted = props.isInverted,
      type = props.type,
      size = props.size,
      href = props.href,
      icon = props.icon,
      shouldSubmit = props.shouldSubmit,
      label = props.label,
      spacing = props.spacing,
      adjacentHorizontalSpacing = props.adjacentHorizontalSpacing,
      adjacentVerticalSpacing = props.adjacentVerticalSpacing,
      children = props.children,
      newWindow = props.newWindow;


  var Element = 'button';
  var loadingIndicator = null;
  var additionalProps = { id: id };
  var isDisabled = props.isDisabled || isLoading;

  var wrapperClasses = (0, _classnames3.default)([styles.wrapper, _defineProperty({}, styles.isBlock, isBlock)]);

  var buttonClasses = (0, _classnames3.default)(styles.button, styles[type], styles[size + 'Size'], (_classnames = {}, _defineProperty(_classnames, styles.isBlock, isBlock), _defineProperty(_classnames, styles.isDisabled, isDisabled), _defineProperty(_classnames, styles.isInverted, isInverted), _defineProperty(_classnames, styles.isLoading, isLoading), _defineProperty(_classnames, styles.placeholder, isPlaceholder), _classnames));

  var onClick = function onClick(event) {
    if (isPlaceholder || isDisabled) {
      event.preventDefault();
      return;
    }

    if (props.onClick) {
      props.onClick(event);
    }
  };

  if (href) {
    Element = 'a';

    additionalProps.href = href;

    if (newWindow) {
      additionalProps.rel = 'noopener';
      additionalProps.target = '_blank';
    }
  } else {
    additionalProps.type = shouldSubmit ? 'submit' : 'button';
    additionalProps.disabled = isDisabled;
  }

  if (isLoading) {
    var loadingIndicatorColor = 'white';

    if (!isInverted && type === 'tertiary') {
      loadingIndicatorColor = 'teal';
    } else if (!isInverted && type === 'tertiaryAlt') {
      loadingIndicatorColor = 'berry';
    }

    loadingIndicator = _react2.default.createElement(
      'span',
      { className: styles.loadingIndicator },
      _react2.default.createElement(_LoadingIndicator2.default, { color: loadingIndicatorColor })
    );
  }

  if (label) {
    additionalProps['aria-label'] = label;
  }

  return _react2.default.createElement(
    _SpacerElement2.default,
    {
      spacing: spacing,
      adjacentVerticalSpacing: adjacentVerticalSpacing,
      adjacentHorizontalSpacing: adjacentHorizontalSpacing,
      className: wrapperClasses,
      isPlaceholder: isPlaceholder,
      element: 'span'
    },
    _react2.default.createElement(
      Element,
      _extends({}, additionalProps, { className: buttonClasses, onClick: onClick, tabIndex: 0 }),
      loadingIndicator,
      _react2.default.createElement(
        'span',
        { className: styles.buttonContent },
        icon && _react2.default.createElement(_Icon2.default, { component: icon, spacing: children ? '0 small 0 0' : undefined, size: 18 }),
        children
      )
    )
  );
}

Button.displayName = 'Button';
Button.propTypes = _extends({
  /** ID for button element */
  id: _propTypes2.default.string,

  /** The type of button, more on that later. */
  type: _propTypes2.default.oneOf(['primary', 'secondary', 'tertiary', 'primaryAlt', 'secondaryAlt', 'tertiaryAlt', 'destructive']),

  /** The contents of the button. */
  children: _propTypes2.default.node,

  /** The icon component to render. */
  icon: _propTypesElementtype2.default,

  /** For use on non-white/non-light-grey backgrounds. */
  isInverted: _propTypes2.default.bool,

  /** Disable the default behaviour and any onClick handlers. */
  isDisabled: _propTypes2.default.bool,

  /** Hides the text and shows a loading state. */
  isLoading: _propTypes2.default.bool,

  /** Whether the button should be full width or not. */
  isBlock: _propTypes2.default.bool,

  /** If provided will output an `<a>` tag vs a `<button>`. */
  href: _propTypes2.default.string,

  /** If used in combination with href, will ensure links open in a new tab. */
  newWindow: _propTypes2.default.bool, // eslint-disable-line react/boolean-prop-naming

  /** When used as a button, sets the 'type' html attribute to 'submit'. Use this when you want a button to submit a form. */
  shouldSubmit: _propTypes2.default.bool,

  /** Label required whenever there is no children, for accessibility. */
  label: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (_ref2) {
    var isPlaceholder = _ref2.isPlaceholder,
        children = _ref2.children;
    return !isPlaceholder && !children;
  }),

  /** Event handlers. */
  onClick: _propTypes2.default.func,

  /** The size of the button. Affects both vertical size and horizontal padding. */
  size: _propTypes2.default.oneOf(['medium', 'small'])

}, _SpacerElement2.default.propTypes);

Button.defaultProps = _extends({
  type: 'primary',
  children: null,
  icon: undefined,
  isInverted: false,
  isDisabled: false,
  isLoading: false,
  isBlock: false,
  href: '',
  newWindow: false,
  shouldSubmit: false,
  onClick: null,
  size: 'medium'
}, _SpacerElement2.default.defaultProps);

Button.placeholderProps = {
  type: 'primary',
  size: 'medium',
  children: 'label'
};